/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';

export const NotInKeyPublicMultibase: core.serialization.ObjectSchema<
    serializers.NotInKeyPublicMultibase.Raw,
    Truvity.NotInKeyPublicMultibase
> = core.serialization.object({
    values: core.serialization.list(core.serialization.string()),
});

export declare namespace NotInKeyPublicMultibase {
    export interface Raw {
        values: string[];
    }
}
